import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export default gql`
  mutation GenerateAgreementsForDisbursement(
    $input: GenerateAgreementsForDisbursementInput!
  ) {
    generateAgreementsForDisbursement(input: $input) {
      __typename
      ... on GenerateAgreementsForDisbursementSuccess {
        agreements {
          id
          title
          type
          resource {
            htmlId
            pdfId
            textId
            textDocumentHtml
          }
          productType
        }
      }
      ... on GenerateAgreementsForDisbursementError {
        ...error
      }
    }
  }
  ${error}
`;
